import plan3d from "./plan-3d.jpg.asset.json";
import plan2d from "./plan-2d.jpg.asset.json";

const photoModules = import.meta.glob("./img-*.jpg.asset.json", {
  eager: true,
  import: "default",
}) as Record<string, { url: string }>;

export const kladnoBytImages = Object.entries(photoModules)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([, asset]) => asset.url);

export const kladnoBytFloorPlans = [
  { image: plan3d.url, label: "Půdorys bytu – 3D" },
  { image: plan2d.url, label: "Půdorys bytu s rozměry" },
];
